<!-- display-mobile-03 preview — full-screen interstitial, single image card -->
<app-mobile-frame>
  <div class="gs-page d-flex flex-column">
    <div class="gs-brand-row d-flex flex-row align-items-center">
      <span class="gs-logo"><img src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png" alt="" /></span>
      <div class="gs-brand-info">
        <a class="gs-long-headline" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
          {{ longHeadline }}
        </a>
        <div class="gs-brand-name">Valamar</div>
      </div>
      <i class="bi bi-info-circle gs-info"></i>
    </div>

    <a class="gs-card d-flex flex-column" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <span class="gs-card-image d-flex align-items-center">
        <img [src]="hotel.image" alt="" />
      </span>
      <span class="gs-card-title">{{ hotel.title }}</span>
      <span class="gs-card-description">{{ hotel.subtitle }}</span>
    </a>

    <div class="gs-actions d-flex flex-row">
      <span class="gs-btn gs-btn-close">Zatvori</span>
      <a class="gs-btn gs-btn-cta" [href]="data.url || null" target="_blank" rel="noopener noreferrer">{{ ctaText }}</a>
    </div>
  </div>
</app-mobile-frame>
